import CircularProgress from '@mui/material/CircularProgress';
import './Loading.css';

export type LoadingProps = {
    size?: number;
    thickness?: number;
};

const Loading = ({ size = 40, thickness = 4 }: LoadingProps) => {
    return (
        <div className="circular-loading-container">
            <CircularProgress color="inherit" size={size} thickness={thickness} />
        </div>
    );
};
export default Loading;
